// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUY = "koupit";
export const FROM = "Od";
export const STROLLER_DETAIL_count_PRODUCTS_IN_BAZAAR = ["%(count)s inzer\u00e1t v bazaru", "%(count)s inzer\u00e1ty v bazaru", "%(count)s inzer\u00e1t\u016f v bazaru"];
export const STROLLER_DETAIL_GO_TO_BAZAAR = "Do bazaru";
export const STROLLER_DETAIL_WHERE_TO_BUY = "Kde koup\u00edm?";
